var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScriptChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9548_2093)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 21H29.3333C25.2907 21 22 24.44 22 28.6692V41.2189C22 45.4481 25.2907 48.8881 29.3333 48.8881H30.9867L35.7867 53.1146C36.4253 53.7072 37.2253 54 38.0187 54C38.7947 54 39.5627 53.7183 40.16 53.1634L45.104 48.8881H46.6667C50.7093 48.8881 54 45.4481 54 41.2189V28.6692C54 24.44 50.7093 21 46.6667 21ZM50 41.2189C50 43.1404 48.5053 44.7049 46.6667 44.7049H44.384C43.9187 44.7049 43.468 44.875 43.1093 45.1846L38.0053 49.6007L33.0067 45.1971C32.6453 44.8792 32.1893 44.7049 31.7173 44.7049H29.3333C27.4947 44.7049 26 43.1404 26 41.2189V28.6692C26 26.7477 27.4947 25.1832 29.3333 25.1832H46.6667C48.5053 25.1832 50 26.7477 50 28.6692V41.2189ZM40 35.6413C40 36.7958 39.104 37.7329 38 37.7329C36.896 37.7329 36 36.7958 36 35.6413C36 34.4867 36.896 33.5496 38 33.5496C39.104 33.5496 40 34.4867 40 35.6413ZM46.6667 35.6413C46.6667 36.7958 45.7707 37.7329 44.6667 37.7329C43.5627 37.7329 42.6667 36.7958 42.6667 35.6413C42.6667 34.4867 43.5627 33.5496 44.6667 33.5496C45.7707 33.5496 46.6667 34.4867 46.6667 35.6413ZM33.3333 35.6413C33.3333 36.7958 32.4373 37.7329 31.3333 37.7329C30.2293 37.7329 29.3333 36.7958 29.3333 35.6413C29.3333 34.4867 30.2293 33.5496 31.3333 33.5496C32.4373 33.5496 33.3333 34.4867 33.3333 35.6413Z",
    fill: "#A2A2A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9548_2093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptChat);
export default __webpack_public_path__ + "static/media/script-chat.607f330571336dcf20eb519e544b806c.svg";
export { ForwardRef as ReactComponent };